import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@indeed/ifl-components';
import Navigation from '../../components/Navigation/Navigation';

const DefaultApplyLayout: React.FunctionComponent = () => {
    return (
        <Box
            sx={{
                minBlockSize: '100vh',
                display: 'flex',
                flexDirection: 'column',
                fontFamily: 'default',
            }}
        >
            {/* Persistent Navigation Section */}
            <Navigation />

            {/* Animated Content Area */}
            <Box
                as="main"
                sx={{
                    flex: 1,
                    transition: 'all 0.3s ease-in-out',
                    position: 'relative',
                }}
            >
                <Outlet />
            </Box>

            {/* Persistent Footer Section */}
            <Box
                sx={{
                    backgroundColor: 'background.secondary',
                    padding: 4,
                    textAlign: 'center',
                    borderBlockStart: '1px solid',
                    borderColor: 'border.subtle',
                    marginBlockStart: 8,
                }}
            >
                <Box sx={{ color: 'foreground.secondary', fontSize: 1 }}>
                    © 2024 Indeed, Inc. All rights reserved.
                </Box>
            </Box>
        </Box>
    );
};

export default DefaultApplyLayout;
